var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoKmdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "249px",
    height: "249px",
    viewBox: "0 0 249 249",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window-2",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#8ACFC5",
    cx: 114.5,
    cy: 114.5,
    r: 114.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(49.000000, 62.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 9
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 25.3193277,
    y: 14.3541667,
    width: 77.0588235,
    height: 77.2916667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "103.478992 91.5157534 129.89916 106 129.89916 1.10416667 103.478992 14.1586687"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "25.3193277 91.5157534 0 106 0 1.10416667 25.3193277 14.1586687"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "116.689076 96.1664883 131 104.895833 131 0 116.689076 7.27086187"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.210084 97.270655 0 106 0 1.10416667 13.210084 8.37502854"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "25.3193277 66.0197891 0 73.9791667 0 32.0208333 25.3193277 37.0885471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "104.579832 67.1225704 131 75.0833333 131 33.125 104.579832 38.1862924"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKmdIcon);
export default __webpack_public_path__ + "static/media/logo-kmd-icon.4ac724216d6693cc44c4077224be5583.svg";
export { ForwardRef as ReactComponent };